
































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AuthorizedSignerTable from "@/employee/components/settings/AuthorizedSignerTable.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { AuthorizedSigner, AuthorizedSignerStatus } from "@/shared/types";
@Component({
  components: {
    GenericLoadingSpinner,
    AuthorizedSignerTable
  }
})
export default class AuthorizedSigners extends Vue {
  bankAccountStore = useBankAccountStore();

  mounted (): void {
    this.bankAccountStore.loadAuthorizedSigners();
  }

  get isLoaded (): boolean {
    return this.bankAccountStore.isAuthoriziedSignersLoaded;
  }

  get showAuthorizedSigners (): boolean {
    return this.authorizedSigners && this.authorizedSigners.length > 0;
  }

  get authorizedSigners (): AuthorizedSigner[] {
    return this.bankAccountStore.authorizedSigners;
  }

  get activeAuthorizedSigners (): AuthorizedSigner[] {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Active);
  }

  get hasActiveAuthorizedSigners (): boolean {
    return this.activeAuthorizedSigners && this.activeAuthorizedSigners.length > 0;
  }

  get inactiveAuthorizedSigners (): AuthorizedSigner[]  {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Inactive);
  }

  get hasInactiveAuthorizedSigners (): boolean {
    return this.inactiveAuthorizedSigners && this.inactiveAuthorizedSigners.length > 0;
  }
}
